import { useEffect } from 'react';
import useSettings from '../hooks/useSettings';

// Wrapper que define document.dir conforme theme.direction (de SettingsContext).
// Em arquitetura Tailwind puro sem MUI, o cache Emotion/rtlPlugin nao e mais
// necessario - CSS e estatico e gerado em build time. Mantemos apenas o
// document.dir para compatibilidade com bibliotecas que leem essa propriedade.

export default function RtlLayout({ children }) {
  const { themeDirection } = useSettings();

  useEffect(() => {
    document.dir = themeDirection;
  }, [themeDirection]);

  // CacheProvider do Emotion nao e necessario em arquitetura Tailwind
  return <>{children}</>;
}
